import { useFeatureFlagEnabled as useFeatureFlagEnabledPostHog } from 'posthog-js/react';

import { config } from '@/config/config';
import { isFeatureFlagOverridden } from '@/lib/posthog/featureFlagOverrides';
import { type FeatureFlags, featureFlags } from '@/lib/posthog/featureFlags';

export const useFeatureFlagEnabled = (flag: FeatureFlags) => {
  const postHogValue = useFeatureFlagEnabledPostHog(featureFlags[flag]);

  return (
    postHogValue === true ||
    isFeatureFlagOverridden({
      isDevelopment: import.meta.env.DEV,
      overrides: config.app.featureFlagOverrides,
      flag: featureFlags[flag],
    })
  );
};
